<div *ngIf="data" class="w-100pc">
    <div *ngIf="data?.exportFormatId === 4 || data?.exportFormatId === 5|| data?.exportFormatId === 2933 || data?.exportFormatId === 2942" class="">
        <button *ngIf="data?.successCount>0 && data?.exportFormatId === 4"
            class="btn eod-btn-warning btn-sm btn-block d-block" (click)="onUserAction(Xeroaction)">
            {{ "Go to Xero (Bills to Pay)" | translate: param }}
        </button>
        <button *ngIf="data?.successCount>0 && data?.exportFormatId === 5"
            class="btn eod-btn-warning btn-sm btn-block d-block" (click)="onUserAction(Xeroaction)">
            {{ "Go to QuickBooks" | translate: param }}
        </button>
        <button class="btn eod-btn-primary btn-sm btn-block d-block" (click)="onUserAction(viewdetailaction)">
            {{ "view_detail" | translate: param }}
        </button>
    </div>
    <!-- <div style="vertical-align: middle;  width: 160px" *ngIf="data?.exportFormatId === 5" class="text-center">
        <button class="btn btn-primary f-11 padding-5" style="width: 130px;" (click)="onUserAction(viewdetailaction)">
            {{ "view_detail" | translate: param }}
        </button>
    </div> -->
    <div *ngIf="data?.exportFormatId !== 4 && data?.exportFormatId !== 5 && data?.exportFormatId !== 2933 && data?.exportFormatId !== 2942"
        class="d-flex align-items-center justify-content-center min-w-9em">
        <a (click)="onUserAction(multiformatdownloadaction)"><i class="fas fa-download eod-text-primary f-22"></i></a>
    </div>
</div>